'use strict';

var React = require('react');

var SvgDragDropMajor = function SvgDragDropMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2 2h1v-2h-1.5a1.5 1.5 0 0 0-1.5 1.5v1.5h2v-1zm3 0h3v-2h-3v2zm8 0h-3v-2h3v2zm-13 3v3h2v-3h-2zm0 5v3h2v-3h-2zm18-5h-2v3h2v-3zm-13 13h3v-2h-3v2zm-5-1a1 1 0 0 0 1 1h2v-2h-1v-1h-2v2zm16-14v-1h-1v-2h1.5a1.5 1.5 0 0 1 1.5 1.5v1.5h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.814 14h-5.314a1.5 1.5 0 0 1-1.5-1.5v-7a1.5 1.5 0 0 1 1.5-1.5h7a1.5 1.5 0 0 1 1.5 1.5v5.314l5.512 2.506a.832.832 0 0 1 .028 1.501l-2.898 1.45a.832.832 0 0 0-.372.371l-1.449 2.898a.832.832 0 0 1-1.501-.028l-2.506-5.512zm-.909-2-.828-1.821c-.318-.7.402-1.42 1.102-1.102l1.821.828v-3.905h-6v6h3.905z"
  }));
};

exports.SvgDragDropMajor = SvgDragDropMajor;
